// Wraps FileReader in a real Promise so callers can `await` it correctly.
// The previous implementation was `async` but never awaited the onload event,
// causing imageSelectedHandler to return an empty object. All callers worked around
// this with a sleep(2000) hack — those sleeps are now removed.
export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
